import React, {useState, useEffect} from "react";
import {connect} from 'react-redux';
//import ProgressBar from 'react-bootstrap/ProgressBar'
//import Table from 'react-bootstrap/Table';
//import Pagination from 'react-js-pagination';
import Pagination from 'react-bootstrap/Pagination';
//import Container from 'react-bootstrap/Container';
import Container from '@material-ui/core/Container';
import {useMediaQuery, useTheme} from '@material-ui/core';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { withStyles } from '@mui/styles';
import {styled} from '@mui/material/styles';
//import { createTheme, ThemeProvider } from '@mui/material/styles';
//import Checkbox from '@mui/material/Checkbox';
//import Typography from '@material-ui/core/Typography';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
//import Button from 'react-bootstrap/Button';
import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/IconButton';
//import Icon from '@material-ui/core/Icon';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
//import Modal from 'react-bootstrap/Modal';
//import Modal from '@material-ui/core/Modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
//import PageItem from 'react-bootstrap/PageItem'
import { Redirect } from 'react-router-dom';
//import { NavLink, Link } from 'react-router-dom';
//import {LinkContainer} from 'react-router-bootstrap';
//import { Nav, NavItem} from "react-bootstrap";
//import DeleteModal from './DeleteModal';
import * as actions from '../store/actions/index';
import * as actionTypes from "../store/actions/actionTypes";
//import AddClientQuick from './AddClientQuick';
//import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
//import { green } from '@material-ui/core/colors';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import CardHeader from '@mui/material/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
//import Collapse from '@material-ui/core/Collapse';
//import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
//import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

//
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
//

import moment from 'moment';
//import { MDBDataTable } from 'mdbreact';
//import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";
import { ExportCsv, ExportPdf } from '@material-table/exporters';
//import {MTableToolbar} from "material-table";
import {MTableToolbar} from "@material-table/core";
import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import DataTable from 'react-data-table-component';
//import TextField from '@material-ui/core/TextField';
//import { Form, Alert } from "react-bootstrap";
import QuickRenew from './QuickRenew';
//import DatatablePage from './DatatablePage';
//import ReactTable from './ReactTable';
import {purple} from "@mui/material/colors/index";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    success: {
        color: theme.palette.getContrastText(purple[500])
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    }
}));

//const StyledChip = withStyles({
//    //root: {
    //    backgroundColor: 'red'// here you can do anything actually
    //},
//    label: {
//        textTransform: 'capitalize',
//    },
//    fontSize: 12
//})(Chip);

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

function Clients(props) {

    const classes = useStyles();
    const [currentSelectedPage, setCurrentSelectedPage] = useState(props.current_page);
    const [modalShow, setModalShow] = useState(false);
    const [myData, setMyData] = useState();
    const [deleteClient, setDeleteClient] = useState();
    const [months, setMonths] = useState("");
    //const [myData, setMyData] = useState();
    const [dataRows, setDataRows] = useState();
    const [filterText, setFilterText] = useState('');
    const [filterData, setFilterData] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [activeCod4kData, setActiveCod4kData] = useState([]);
    const [activeCrown4kData, setActiveCrown4kData] = useState([]);
    const [expiredData, setExpiredData] = useState([]);
    const [labelAll, setLabelAll] = useState("ALL");
    const [labelActive, setLabelActive] = useState("ACTIVE");
    const [labelCod4k, setLabelCod4k] = useState("COD4K");
    const [labelCrown4k, setLabelCrown4k] = useState("CROWN4K");
    const [labelExpired, setLabelExpired] = useState("EXPIRED");
    const [expanded, setExpanded] = React.useState(false);
    const [value, setValue] = React.useState('ALL');
    const theme = useTheme();
    const isSmallOrLess =
        useMediaQuery(theme.breakpoints.down('sm'));


    useEffect(() => {
        console.log('logging dashboard client list');
        props.onInitializeGetClient();
        props.onInitializeSaveClient();
        props.onInitializeAddClient();
        props.onInitializeDeleteClient();
        props.onInitializeRetrieveCredits();
        props.onGetClientList(props.token, currentSelectedPage, props.searchClients);

    }, [currentSelectedPage]);

    useEffect(() => {
       //console.log('select page: ', currentSelectedPage);
    }, [currentSelectedPage]);

    useEffect(() => {
        if (props.isDeleteClient.client){
            props.onGetClientList(props.token, currentSelectedPage);
            var successMessage = 'Deleted ' + props.isDeleteClient.client.name;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});

            setModalShow(false);
        }
    },[props.isDeleteClient.client]);

    let clientsData = [];
    let data2 = {};
    let loadedData = null;
    //<Button onClick={()=> setModalClient(client.name)} variant="contained" startIcon={<HighlightOffIcon />} size="small" color="secondary" >Del</Button>
    useEffect(() => {
        if (props.clients && props.clients.length){
            var currentDate = new Date();
            var now = moment().format('YYYY-MM-DD');

            clientsData = props.clients.map((client) => {
                //console.log('inside client map', client);
                //login: <a href="#" onClick={() => setCurrentClient(client)}>{client.name}</a>,
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                let clientStatus = client.status ? 'ACTIVE' : 'INACTIVE';
                let serverName = "T4k";
                let expiredClient = moment(now).isAfter(moment(expiry));
                let disabled = (expiredClient)?false:true;
                //console.log('Logging now: ', now);
                //console.log('Logging expiry ', client.name, ' ', expiry);
                if (client.server === 1){
                    serverName = "COD 4K";
                } else if (client.server == 2){
                    serverName = "CROWN 4K";
                }
                return {
                    login: client.name,
                    name: client.name,
                    description: client.description,
                    mac: client.ministra ? "" : client.mac,
                    ministra: client.ministra ? "Yes" : "",
                    expiry: moment(client.expiry).format('YYYY-MM-DD'),
                    expired: moment(now).isAfter(moment(expiry)),
                    status: (expiredClient)?"INACTIVE":clientStatus,
                    server: client.server,
                    serverName: serverName,
                    actions:
                        <Stack direction="row" spacing={1}>
                            <QuickRenew name={client.name}/>
                            <IconButton disabled={!expiredClient} onClick={()=> setModalClient(client.name)} size="small" sx={{ padding: '0px' }}><DeleteOutline fontSize="small" /></IconButton>
                        </Stack>
                };
            });

            let filteredActiveData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(expiry).isAfter(moment(now))){
                    return true;
                } else {
                    return false;
                }
            });

            let filteredExpiredData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(now).isAfter(moment(expiry))){
                    return true;
                } else {
                    return false;
                }
            });

            let filteredActiveCod4kData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(expiry).isAfter(moment(now)) && client.server === 1){
                    return true;
                } else {
                    return false;
                }
            });

            let filteredActiveCrown4kData = clientsData.filter(client => {
                var expiry = moment(client.expiry).format('YYYY-MM-DD');
                if (moment(expiry).isAfter(moment(now)) && client.server === 2){
                    return true;
                } else {
                    return false;
                }
            });

            console.log('filteredActiveCod4kData', filteredActiveCod4kData);

            setLabelAll("ALL (" + clientsData.length + ")");
            setLabelActive("ACTIVE (" + filteredActiveData.length + ")");
            setLabelExpired("EXPIRED (" + filteredExpiredData.length + ")");
            setLabelCod4k("COD4K (" + filteredActiveCod4kData.length + ")");
            setLabelCrown4k("CROWN4K (" + filteredActiveCrown4kData.length + ")");
            setActiveData(filteredActiveData);
            setActiveCod4kData(filteredActiveCod4kData);
            setActiveCrown4kData(filteredActiveCrown4kData);
            setExpiredData(filteredExpiredData);
            setDataRows(clientsData);
            setFilterData(clientsData);


        }

    },[props.clients]);

    useEffect(() => {
        //console.log('insided useEffect', filterText);
        if (dataRows && dataRows.length){
            //console.log('filter data', clientsData);
            let data = dataRows.filter(item => {
                if(item.name && item.name.toLowerCase().includes(filterText.toLowerCase())){
                    return true;
                } else if (item.mac && item.mac.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else if (item.status && item.status.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else if (item.description && item.description.toLowerCase().includes(filterText.toLowerCase())) {
                    return true;
                } else {
                    return false;
                }
            });
            setFilterData(data);
        }

    }, [filterText]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handlePageChange = (e) => {
        //console.log('active page ', e.target.text);
        const page = e.target.text;
        if(page){
            if(page == 'First'){
                setCurrentSelectedPage(1);
            } else if(page == 'Last'){
                setCurrentSelectedPage(props.total_pages);
            } else {
                setCurrentSelectedPage(page);
            }
        }
    };

    const setCurrentClient = (client) => {
        console.log(client);
        props.onSetClient(client); //client name
        props.history.push('/updateclient');
        //setClient(client);
    };

    const handleClose = () => setModalShow(false);

    const setModalClient = (client) => {
        setDeleteClient(client);
        console.log('logging delete client', deleteClient);
        setModalShow(true);
    };

    const handleDeleteClient = () => {
        console.log('deleting...', deleteClient);
        props.onDeleteClient(props.token, deleteClient);
    };

    const handleToggle = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        const id = target.id;

        console.log('logging name', id);
        console.log('logging value', value);

    };

    const handleChangeTabs = (event, newValue) => {
        setValue(newValue);
        if (newValue === "ALL"){
            setFilterData(dataRows);
        } else if (newValue === "ACTIVE"){
            setFilterData(activeData);
        } else if (newValue === "COD4K"){
            setFilterData(activeCod4kData);
        } else if (newValue === "CROWN4K"){
            setFilterData(activeCrown4kData);
        } else {
            setFilterData(expiredData);
        }
    };

    let items = [];
    //let pageNumbers = <></>;
    //<Chip label={labelAll} color="secondary" style={{marginRight: 5}} onClick={()=> setFilterData(dataRows)}/>
    //<Chip label={labelActive} color="secondary" style={{marginRight: 5}} onClick={()=> setFilterData(activeData)}/>
    //<Chip label={labelExpired} color="secondary" style={{marginRight: 5}} onClick={()=> setFilterData(expiredData)}/>

    for (let number = 1; number <= props.total_pages; number++){
        items.push(
            <Pagination.Item key={number} active={number === props.current_page} >
                {number}
            </Pagination.Item>
        );
    }


    let pageNumbers = (
        <Container>
            <Row mx-lg-n5>
                <Col></Col>
                <Col>
                    <Pagination onClick={handlePageChange}>
                        <Pagination.Item disabled={(props.current_page==1)?true:false}>First</Pagination.Item>
                        {items}
                        <Pagination.Item disabled={(props.current_page==props.total_pages)?true:false}>Last</Pagination.Item>
                    </Pagination>
                </Col>
                <Col></Col>
            </Row>
        </Container>

    );

    let loading = (
        <Container>
            <Row>
                <Col></Col>
                <Col>
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </Col>
                <Col></Col>
            </Row>
        </Container>
    );

    //(rowData.status === 'ACTIVE') ? <Chip label={rowData.status} color="success" size="small"/> : <Chip label={rowData.status} color="error" size="small"/>

    const dataColumnsMaterial = [

        {
            title: 'Server',
            field: 'serverName',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'

            }
        },
        {
            title: 'Login',
            field: 'login',
            render: (rowData) => <a href="#" onClick={() => setCurrentClient(rowData.login)}>{rowData.login}</a>,
            cellStyle: {
                fontSize: 13,
                padding: '6px'

            }
        },
        {
            title: 'Description',
            field: 'description',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            }
        },
        {
            title: 'MAC',
            field: 'mac',
            cellStyle: {
                fontSize: 13,
                padding: '6px'
            }
        },
        {
            title: 'Ministra',
            field: 'ministra',
            hidden: isSmallOrLess,
            cellStyle: {
                fontSize: 12,
                padding: '6px'
            },
            width: "8%",
            render: (rowData) => (rowData.ministra === 'Yes') ? <Check /> : ""
        },
        {
            title: 'Status',
            field: 'status',
            hidden: isSmallOrLess,
            cellStyle: {
                padding: '6px',
                width:10,
                maxWidth: 10
            },
            headerStyle: {
                width:10,
                maxWidth: 10
            },
            width: "9%",
            render: (rowData) => {
                if (rowData.status === 'ACTIVE' && !rowData.expired) {
                    return <StyledChip label={rowData.status} sx={{backgroundColor: '#4caf50'}} size="small"/>;
                } else {
                    return <StyledChip label={rowData.status} sx={{backgroundColor: '#f44336'}} size="small"/>;
                }
            }
        },
        {
            title: 'Expiry',
            field: 'expiry',
            cellStyle: {
                padding: '6px'
            },
            render: (rowData) => (rowData.expired) ? <StyledChip label={rowData.expiry} sx={{backgroundColor: '#f44336'}} size="small"/> : <StyledChip label={rowData.expiry} sx={{backgroundColor: '#4caf50'}} size="small"/>
        },
        {
            title: 'Actions',
            field: 'actions',
            sorting: false,
            hidden: isSmallOrLess,
            cellStyle: {
                //fontSize: 12,
                padding: '6px'
            },
            headerStyle: {
                textAlign: "center"
            }
        }
    ];

    const detailsPanel = [
        props => {
            if (!isSmallOrLess){
                return {
                    icon: () => null,
                    render: () => null
                }
            }
            return {
                disabled: !isSmallOrLess,
                render: (rowData) => {
                    return (
                        <Box sx={{ flexGrow: 1, padding: "5px" }}>
                        <Grid container spacing={3}>
                        <   Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Server
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.serverName}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Status
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {(rowData.rowData.status === 'ACTIVE' && !rowData.rowData.expired) ? 
                                        <StyledChip label={rowData.rowData.status} sx={{backgroundColor: '#4caf50'}} size="small"/>:
                                        <StyledChip label={rowData.rowData.status} sx={{backgroundColor: '#f44336'}} size="small"/>}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                    <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Ministra
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {(rowData.rowData.ministra === 'Yes') ? <Check /> : ""}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Description
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.description}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item zeroMinWidth >
                                <Grid container spacing={1}>
                                    <Grid item>
                                        <Typography sx={{fontSize: 13, fontWeight: 'bold'}} variant="h6" component="div">
                                        Actions
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        {rowData.rowData.actions}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        </Box>
                    )
                }
            }
        }
        
    ];

    // <Grid item md={8}></Grid>
    //<Paper  elevation={1}>
    //</Paper>
    //<Container>
    //</Container>
    //<div className="lander">
    //rowStyle: {
    //    fontSize: 13,
    //},
    //headerStyle: {
    //    fontSize: 13
    //},
    return (
        <Container maxWidth="xl" disableGutters={isSmallOrLess}>
                <Dialog
                    open={modalShow}
                    onClose={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                >
                    <DialogTitle id="form-dialog-title">Delete?</DialogTitle>

                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete <b>{deleteClient}</b>?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button color="primary" onClick={handleDeleteClient}>Yes</Button>
                        <Button color="secondary" onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>

                    <Grid container spacing={2}>
                        <Grid xs={12} md={12} item>
                        
                                <Card>
                                    <CardHeader 
                                        title="Manage Clients" 
                                        titleTypographyProps={{
                                            fontSize: 17,
                                            fontWeight: 'bold'
                                        }} 
                                    />
                                    <Divider variant="middle" />
                                    <CardContent sx={{p:1}}>
                                        <MaterialTable
                                            icons={tableIcons}
                                            columns={dataColumnsMaterial}
                                            data={filterData}
                                            detailPanel={detailsPanel}
                                            actions={[
                                                {
                                                    icon: tableIcons.Add,
                                                    tooltip: 'Add Client',
                                                    isFreeAction: true,
                                                    onClick: (event) => props.history.push('/addclient')
                                                }
                                            ]}
                                            title=""
                                            options={{
                                                pageSize: 10,
                                                emptyRowsWhenPaging: false,
                                                pageSizeOptions: [10, 20, 30, 40, 50, 100],
                                                padding: "dense",
                                                headerStyle: {padding: '5px', fontWeight: 'bold', fontSize: 13},
                                                tableLayout: "auto",
                                                exportMenu: [{
                                                    label: 'Export PDF',
                                                    exportFunc: (dataColumnsMaterial, filterData) => ExportPdf(dataColumnsMaterial, filterData, 'myClients')
                                                }, {
                                                    label: 'Export CSV',
                                                    exportFunc: (dataColumnsMaterial, filterData) => ExportCsv(dataColumnsMaterial, filterData, 'myClients')
                                                }]
                                            }}
                                            components={{
                                                Toolbar: props => (
                                                <div>
                                                <MTableToolbar {...props} />
                                                <div style={{padding: '0px 10px'}}>
                                                    <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
                                                        <Tabs
                                                            value={value}
                                                            onChange={handleChangeTabs}
                                                            textColor="inherit"
                                                            indicatorColor="primary"
                                                            aria-label="secondary tabs"

                                                        >
                                                            <Tab sx={{fontSize: 12}} value="ALL" label={labelAll} />
                                                            <Tab sx={{fontSize: 12}} value="ACTIVE" label={labelActive} />
                                                            <Tab sx={{fontSize: 12}} value="COD4K" label={labelCod4k} />
                                                            <Tab sx={{fontSize: 12}} value="CROWN4K" label={labelCrown4k} />
                                                            <Tab sx={{fontSize: 12}} value="EXPIRED" label={labelExpired} />
                                                        </Tabs>
                                                    </Box>
                                                </div>
                                                </div>
                                             ),
                                            }}

                                        />
                                    </CardContent>
                                </Card>

                        </Grid>
                    </Grid>

        </Container>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetClientList: (token, page, search) => dispatch(actions.clientList(token, page, search)),
        onSetClient: (name) => dispatch(actions.setClient(name)),
        onDeleteClient: (token, name) => dispatch(actions.deleteClient(token, name)),
        onInitializeGetClient: () => dispatch(actions.initializeGetClient()),
        onInitializeAddClient: () => dispatch(actions.initializeAddClient()),
        onInitializeSaveClient: () => dispatch(actions.initializeSaveClient()),
        onInitializeDeleteClient: () => dispatch(actions.initializeDeleteClient()),
        onInitializeRetrieveCredits: () => dispatch(actions.initializeRetrieveCredits()),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        clients: state.clients.client_list,
        isLoading: state.clients.loading,
        total_clients: state.clients.total,
        current_page: state.clients.current_page,
        per_page: state.clients.per_page,
        total_pages: state.clients.total_pages,
        isSetLoginName: state.clientReducer.name,
        isDeleteClient: state.deleteClientReducer,
        searchClients: state.searchClients.search

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Clients);